import { Button, Overlay } from "matsuri-ui"
import { css } from "@emotion/react"
import { useCallback, useState } from "react"
import CloseIcon from "@mui/icons-material/Close"

interface Image {
    id: string
    imageUrl: string
}

export const useImageViewerOverlay = () => {
    const [openedImage, setOpenedImage] = useState<Image | undefined>(undefined)
    return {
        openedImage,
        openImageViewer: useCallback(
            (image: Image) => setOpenedImage(image),
            []
        ),
        closeImageViewer: useCallback(() => setOpenedImage(undefined), [])
    }
}

export const ImageViewerOverlay = ({
    onClose,
    openedImage
}: {
    openedImage?: Image
    onClose: () => void
}) => {
    return (
        <Overlay open={!!openedImage}>
            <div
                css={css`
                    display: flex;
                    flex-flow: column;
                    justify-content: center;
                    height: 100vh;
                `}
            >
                <div
                    css={css`
                        position: relative;
                    `}
                >
                    <div
                        css={css`
                            position: absolute;
                            top: -32px;
                            right: 0;

                            display: flex;
                            justify-content: flex-end;
                        `}
                    >
                        <Button
                            type="button"
                            size="small"
                            icon={<CloseIcon />}
                            css={css`
                                color: white;
                            `}
                            onClick={onClose}
                        />
                    </div>

                    {openedImage && (
                        <div
                            css={css`
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            `}
                        >
                            <img
                                key={openedImage.id}
                                src={openedImage.imageUrl}
                                css={css`
                                    max-width: calc(100vw - 32px);
                                    max-height: calc(100vh - 40px);
                                    object-fit: contain;
                                `}
                                loading="lazy"
                                alt=""
                            />
                        </div>
                    )}
                </div>
            </div>
        </Overlay>
    )
}
